import {
  IonIcon,
  IonText,
  IonCard,
  IonRow,
  IonCol,
  IonGrid
} from '@ionic/react';
import {
  newspaperOutline, 
  peopleOutline, 
  hammerOutline, 
  locationOutline, 
} from "ionicons/icons"

import Fade from 'react-reveal/Fade';
import "./FeatureSection.css";

const featureData = [
  {
      icon: newspaperOutline,
      title: 'Monthly Business Statements',
      description: 'Simplify business claims with monthly statements and trip receipts directly in your inbox.'
  },
  {
      icon: hammerOutline,
      title: 'Account Management',
      description: 'Dedicated service from our support team for business users.'
  },
  {
      icon: peopleOutline,
      title: 'Manage Team Members',
      description: 'Add multiple members under one business account for smoother processes and transparency.'
  },
  {
      icon: locationOutline,
      title: 'Add Multiple Stops',
      description: 'Reduce operational costs by adding more than one stop in a single trip.'
  }
]

const FeaturesForBusinessMobile = () => {

  return(
      <div className='feature-section' style={{
          // minHeight:'90vmax', 
          height:'fit-content', 
          overflow:'hidden',
          paddingBlock:'10px',
          background:'#F9F6F6'
      }}>
      <IonGrid style={{
          height:'fit-content',
          paddingBlock:'20px',
          paddingBottom: '40px',
          display:'flex',
          flexDirection:'column',
          alignItems:'flex-start',
          justifyContent:'flex-start',
          paddingInline: '5%',
      }}>
          <IonRow style={{maxWidth:'1200px', width:'100%'}}>
              <IonCol style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'flex-start', paddingLeft:'20px',maxWidth:'100%'}}>
                  <IonText 
                  className="font-baloo"
                  style={{
                  border:'none',
                  fontSize:'0.85rem',
                  fontWeight:'300',
                  fontFamily:"Baloo Thambi 2",
                  color:'#545252',
                  height:'fit-content',
                  }}>
                      RydeSEND
                  </IonText>
                  <IonText 
                  className="font-baloo"
                  style={{
                  border:'none',
                  fontSize:'1.5rem',
                  fontWeight:'600',
                  fontFamily:"Baloo Thambi 2",
                  color:'#545252',
                  height:'fit-content',
                  marginLeft:'0px',
                  }}>
                      Features for Businesses
                  </IonText>
              </IonCol>
          </IonRow>
          {/* <IonRow style={{maxWidth:'1200px', width:'100%'}}> */}
          {featureData.map((item, index) => {
              return <IonRow key={index} style={{
                  alignItems:'center',
                  justifyContent:'flex-start',
                  // paddingInline: '10%',
                  paddingBlock: '20px',
                  color: '#E93864',
              }}>
                  <div style={{
                      display:'flex',
                      flexDirection:'column',
                      justifyContent:'center',
                      alignItems:'center',
                      padding: '1rem',
                      background: '#E93864',
                      borderRadius: '50%',
                      fontSize: '1.5rem',
                      marginInline: '20px',
                  }}>
                      <IonIcon icon={item.icon} style={{
                          color: 'white',
                          background: '#E93864',
                      }}></IonIcon>
                  </div> 
                  <IonCol style={{
                      display:'flex',
                      flexDirection:'column',
                      width: '100%',
                  }}>
                      <IonText
                      className="font-baloo"
                       style={{
                          fontSize:'1.25rem',
                          fontWeight:'600',
                          fontFamily:"Baloo Thambi 2"
                      }}>{item.title}</IonText>
                      <IonText 
                      className="font-baloo"
                      style={{
                          fontSize:'1rem',
                          fontFamily:"Baloo Thambi 2"
                      }}
                      >{item.description}</IonText>
                  </IonCol>
              </IonRow>
          })}
          {/* </IonRow> */}
      </IonGrid>
      </div>
  )
}

const FeaturesForBusinessDesktop = () => {
  return(
      <div style={{
          height:'fit-content', 
          overflow:'hidden',
          marginBlockEnd:'20px',
          // background:'#F9F6F6'
          }}>
      <IonGrid style={{
          height:'fit-content',
          background:'white',
          paddingBlock: '0px !important',
          display:'flex',
          flexDirection:'column',
          alignItems:'center',
          justifyContent:'flex-start',
      }}>
          <IonRow style={{maxWidth:'1200px', width:'100%'}}>
              <IonCol style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'flex-start', maxWidth:'100%', marginLeft:'20px'}}>
                  <IonText 
                  className="font-baloo font-s"
                  style={{
                  border:'none',
                  color:'#545252',
                  height:'fit-content',
                  lineHeight: '1.5rem',
                  fontFamily:"Baloo Thambi 2",
                  }}>
                      RydeSEND
                  </IonText>
                  <IonText 
                  className="font-opensans font-l"
                  style={{
                  border:'none',
                  color:'#545252',
                  height:'fit-content',
                  marginLeft:'0px',
                  lineHeight: '1.5rem',
                  fontWeight: '800',
                  fontFamily:"Baloo Thambi 2",
                  }}>
                      Features for Businesses
                  </IonText>
              </IonCol>
          </IonRow>
          <IonRow style={{maxWidth:'1200px', width:'100%'}}>
          {featureData.map((item, index) => {
              return <IonCol size={12} sizeSm={6} key={index} style={{padding:'18px'}}>
                  <IonCard style={{
                      display:'flex',
                      flexDirection:'column',
                      justifyContent:'flex-start',
                      alignItems:'flex-start',
                      padding: '47px',
                      borderRadius: '28px',
                      fontFamily:"Baloo Thambi 2",
                      color:'#E93864',
                      boxShadow: '0px 2px 8px 2px rgba(166,162,162,0.22)',
                      width: "100%",
                      minWidth: "430px !important",
                  }}
                  className="ionCard"
                  >
                      <div style={{
                          display:'flex',
                          flexDirection:'column',
                          justifyContent:'center',
                          alignItems:'center',
                          padding: '10px',
                          background: '#E93864',
                          borderRadius: '50%',
                          fontSize: '1.5rem',
                      }}>
                          <IonIcon icon={item.icon} style={{
                              color: 'white',
                              background: '#E93864',
                          }}></IonIcon>
                      </div>
                      <IonText 
                      className="font-baloo font-l"
                      style={{
                          lineHeight:'1.5rem',
                          fontWeight:'600',
                          paddingBlock:'1.2rem',
                          fontFamily:"Baloo Thambi 2"
                      }}>{item.title}</IonText>
                      <IonText 
                      className="font-baloo font-s"
                      style={{
                          lineHeight:'1rem',
                          fontFamily:"Baloo Thambi 2"
                      }}
                      >{item.description}</IonText>
                  </IonCard>
              </IonCol>
          })}
          </IonRow>
      </IonGrid>
      </div>
  )
}

const FeaturesSection = (userDevice) => {
  return (<Fade up>{userDevice==='mobile'? FeaturesForBusinessMobile():FeaturesForBusinessDesktop()}</Fade>)
}

export default FeaturesSection;
